import { VForm } from 'vuetify/lib/components/VForm';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.form)?_c(VForm,{attrs:{"value":_vm.form.isValid},on:{"submit":function($event){$event.preventDefault();return _vm.submitted.apply(null, arguments)}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }